import moment from 'moment';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore TODO add defs for analytics
import { track } from '@fenderdigital/analytics';

export interface SessionData {
  durationFormatted: string;
  locale: string;
  sessionId: string;
  timezone: string;
  createdAt: string;
}
export interface Analytics {
  videosWatched: number;
  lessonsComplete?: number;
}
interface MilestoneComplete {
  sessionData: SessionData;
  userID: string;
  analytics: Analytics;
  milestones: number;
}

interface FireIcon {
  sessionData: SessionData;
  userID: string;
  isOnFire: boolean;
}

interface StreaksAnnouncement {
  sessionData: SessionData;
  userID: string;
}

function trackSessionData(data: MilestoneComplete): void {
  const siteId = process.env.REACT_APP_CLIENT_SITE_ID;
  const { sessionData, userID, analytics, milestones }: MilestoneComplete = data || {};
  const { durationFormatted, locale, sessionId, timezone, createdAt } = sessionData || '';
  const { videosWatched }: Analytics = analytics || {};
  const incrementedMilestone: number = milestones + 1;
  const endDate: string = moment().format();
  const today = moment();
  const weekOf: string = today.startOf('week').format();
  track(
    'Session Milestone Completed',
    {
      locale,
      timezone,
      milestone_type: 'Daily Streak',
      start_date: createdAt,
      end_date: endDate,
      fc_id: userID,
      fc_session_id: sessionId,
      milestone_context: {
        milestone_number: incrementedMilestone,
        session_duration: durationFormatted,
        week_of: weekOf,
      },
      videos_completed: videosWatched,
    },
    siteId,
  );
}

function trackStreaksAnnouncment(data: StreaksAnnouncement): void {
  const siteId = process.env.CLIENT_SITE_ID;
  const { sessionData, userID }: StreaksAnnouncement = data || {};
  const { locale, sessionId, timezone } = sessionData || '';
  track('Streaks Announcements', {
    locale,
    timezone,
    fc_id: userID,
    fc_session_id: sessionId,
    site_id: siteId,
  });
}

function trackFireIcon(data: FireIcon): void {
  const siteId = process.env.REACT_APP_CLIENT_SITE_ID;
  const { sessionData, userID, isOnFire }: FireIcon = data || {};
  const { locale, sessionId, timezone } = sessionData || '';
  const state = isOnFire ? 'Active' : 'Inactive';
  track(
    'Fire Icon',
    {
      state,
      locale,
      timezone,
      fc_id: userID,
      fc_session_id: sessionId,
    },
    siteId,
  );
}

export { trackSessionData, trackStreaksAnnouncment, trackFireIcon };
